import dayjs from "dayjs";

export function pctFromString(s) {
  return parseFloat(String(s).replace("%", "")) || 0;
}

export function bandFor(pct) {
  if (pct > 80) return "green";
  if (pct >= 50) return "orange";
  return "red";
}

export const BAND_COLORS = {
  green: { bg: "#ecfdf5", text: "#047857", border: "#a7f3d0", dot: "#10b981" },
  orange: { bg: "#fffbeb", text: "#b45309", border: "#fde68a", dot: "#f59e0b" },
  red: { bg: "#fff1f2", text: "#be123c", border: "#fecdd3", dot: "#f43f5e" },
};

export function fmtNum(n) {
  const num = Number(n) || 0;
  return num >= 1000 ? num.toLocaleString("en-IN") : String(num);
}

export function getMonthRange(dateInMonth) {
  const d = dayjs(dateInMonth);
  return {
    StartDate: d.startOf("month").format("YYYY-MM-DD"),
    EndDate: d.endOf("month").format("YYYY-MM-DD"),
  };
}

export function getPreviousMonth(dateInMonth) {
  return dayjs(dateInMonth).subtract(1, "month");
}

export function monthLabel(dateInMonth) {
  return dayjs(dateInMonth).format("MMMM YYYY");
}

function prettifyMetricName(raw) {
  const stripped = raw
    .trim()
    .replace(/\s*Target\s*$/i, "")
    .trim();
  return stripped
    .split(" ")
    .filter(Boolean)
    .map((w) => w[0].toUpperCase() + w.slice(1))
    .join(" ");
}

export function adaptBranchPerformanceResponse(apiResponse, monthLabelText) {
  const rows = apiResponse?.ResultData || [];
  if (!rows.length) return null;

  const byRowName = {};
  rows.forEach((row) => {
    byRowName[row.RowName] = row;
  });

  const targetRow = byRowName.Target || {};
  const achievedRow = byRowName.Achieved || {};
  const pctRow = byRowName["TargetAchievement(%)"] || {};
  const statusRow = byRowName.TargetStatus || {};
  const scoreRow = byRowName.MetricScore || {};
  const totalScoreRow = byRowName.TotalScore || {};

  const metaKeys = ["BranchName", "RowName"];
  const metricKeys = Object.keys(targetRow).filter(
    (k) => !metaKeys.includes(k),
  );

  const Metrics = metricKeys.map((key) => ({
    MetricName: prettifyMetricName(key),
    Target: Number(targetRow[key]) || 0,
    Achieved: Number(achievedRow[key]) || 0,
    TargetAchievement: pctRow[key] || "0.00%",
    TargetStatus: statusRow[key] || "Not Reached",
    MetricScore: Number(scoreRow[key]) || 0,
  }));

  const TotalScore = Number(totalScoreRow[metricKeys[0]]) || 0;

  return {
    BranchName: rows[0].BranchName,
    Month: monthLabelText,
    TotalScore,
    Metrics,
  };
}
